// #region Imports
import AppRootLayout from "@/components/templates/app-root.template";
import Container from "@/services/container/container.service";
import WrapperProvider from "@/services/wrapper/wrapper.provider";
import { InitColorSchemeScript } from "@mui/material";
import { createRootRouteWithContext, HeadContent, Outlet, Scripts } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

import "@fontsource-variable/inter";
import "@fontsource-variable/jetbrains-mono";
import "@fontsource-variable/roboto";

// #endregion

// #region Root Route
export const Route = createRootRouteWithContext<Container>()({
    head: () => ({
        meta: [
            { charSet: "utf-8" },
            {
                name: "viewport",
                content: "width=device-width, initial-scale=1",
            },
            {
                title: "Furniturr - Optimizare Inteligentă a Tăierii Materialelor",
                description:
                    "Instrument profesional de optimizare a materialelor pentru constructori de mobilier și producători. Minimizează risipa, eficientizează cu scheme de tăiere inteligente.",
            },
        ],
        links: [
            {
                rel: "icon",
                type: "image/svg+xml",
                href: "/images/logo.svg",
            },
        ],
        scripts: [
            {
                children: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-PCG6Z63G');`,
            },
        ],
    }),
    component: Root,
});
// #endregion

// #region Component
function Root() {
    return (
        <html suppressHydrationWarning>
            <head>
                <HeadContent />
            </head>
            <body
                style={{
                    userSelect: "none",
                    WebkitUserSelect: "none",
                    MozUserSelect: "none",
                    msUserSelect: "none",
                }}
            >
                <noscript>
                    <iframe
                        src="https://www.googletagmanager.com/ns.html?id=GTM-PCG6Z63G"
                        height="0"
                        width="0"
                        style={{ display: "none", visibility: "hidden" }}
                    ></iframe>
                </noscript>
                {/* InitColorSchemeScript must come before WrapperProvider to prevent SSR flickering */}
                <InitColorSchemeScript attribute="class" />
                <WrapperProvider>
                    <AppRootLayout>
                        <Outlet />
                        <TanStackRouterDevtools />
                    </AppRootLayout>
                </WrapperProvider>
                <Scripts />
            </body>
        </html>
    );
}
// #endregion
